// src/index.js
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import App from "./App";
import "./App.css";

import { ScannerProvider } from "./utils/ScannerContext";
import CameraScannerPage from "./components/shared/CameraScannerPage";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScannerProvider>
        <Routes>
          <Route path="/scan" element={<CameraScannerPage />} />
          <Route path="/*" element={<App />} />
        </Routes>
      </ScannerProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// ✅ Service Worker (production only)
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
      window.__SW_REG__ = reg;

      // If update already waiting
      if (reg.waiting && navigator.serviceWorker.controller) {
        window.dispatchEvent(new Event("infocon-sw-update"));
      }

      reg.addEventListener("updatefound", () => {
        const installing = reg.installing;
        if (!installing) return;

        installing.addEventListener("statechange", () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) {
            window.__SW_REG__ = reg;
            window.dispatchEvent(new Event("infocon-sw-update"));
          }
        });
      });

      // periodic update checks
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
    } catch (err) {
      console.error("SW register failed", err);
    }
  });
}
